import { NAME_SPACE as ns } from './constants';

export const SET_SUGGESTIONS = `${ns} SET_SUGGESTIONS`;

export const SET_SEARCHES = `${ns} SET_SEARCHES`;
